import { Box, Button, Grid, Modal, Typography } from '@mui/material';
import { Stack } from '@mui/system';
import { useState } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { useDispatch } from 'react-redux';
import { setHasInputChange, setHasInputNoChange } from 'store/ResponseTemplate/actions';
const EditConfirmationModal = ({ parentModalClose, handleFormStateChange }) => {
    const dispatch = useDispatch();
    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        bgcolor: '#ffffff',
        // boxShadow: 24,
        maxWidth: '570px',
        width: '100%'
    };
    const [open, setOpen] = useState(true);
    const handleClose = (type) => {
        setOpen(false);
        parentModalClose(type);

        if (type === 'Y') {
            handleFormStateChange();
        }
    };
    const handleCloseModal = () => {
        setOpen(false);
        dispatch({ type: setHasInputChange, hasInputValue: false });
        dispatch({ type: setHasInputNoChange, hasInputNoChange: true });
    };
    return (
        <Modal open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
            <Box sx={style} className="modal-box edit-confirm">
                <PerfectScrollbar
                    style={{ maxHeight: 'calc(100vh - 100px)', padding: '0 12px' }}
                    options={{ suppressScrollX: true, useBothWheelAxes: false }}
                >
                    <Stack gap={4}>
                        <Typography variant="h6" component="h2" color="#00214D" fontSize="1.25rem" fontWeight="400" fontFamily="Poppins">
                            Close without saving?
                        </Typography>
                        <Typography component="p" fontSize="0.875rem" color="#00214D">
                            Any changes made will be lost.
                        </Typography>

                        <Stack direction="row" justifyContent="space-between" alignItems="center">
                            <Stack>
                                <Button
                                    disableRipple
                                    variant="text"
                                    onClick={handleCloseModal}
                                    sx={{
                                        fontSize: '1rem',
                                        color: '#00214D'
                                    }}
                                >
                                    Close
                                </Button>
                            </Stack>
                            <Stack direction="row" justifyContent="flex-end" gap="10px">
                                <Button variant="outlined" className="alternate-reversed" onClick={() => handleClose('N')}>
                                    Don't save changes
                                </Button>
                                <Button className="alternate" onClick={() => handleClose('Y')}>
                                    Save
                                </Button>
                            </Stack>
                        </Stack>
                    </Stack>
                    {/* <>
                        <Box className="modal-header">
                            <h3>Changes have been made to the question. Would you like to cancel anyways?</h3>
                        </Box>
                        <Grid item xs={12}>
                            <Box className="modal-footer-2">
                                <Button className="alternate-reversed" onClick={() => handleClose('Y')}>
                                    Yes
                                </Button>
                                <Button type="submit" className="alternate" onClick={() => handleClose('N')}>
                                    No
                                </Button>
                            </Box>
                        </Grid>
                    </> */}
                </PerfectScrollbar>
            </Box>
        </Modal>
    );
};

export default EditConfirmationModal;
